export default __webpack_public_path__ + "static/twitterlight-dbf8c61c330b4813a87698cc835a9da4.png";